import { React, useTranslation, css } from '../../..';
import { Icon, Tooltip, Message } from '@weezevent/nacre';

function TableError({ quotas = false }) {
    const { t } = useTranslation();
    if (quotas) {
        return (
            <div className={css[('error-icon', 'quotas')]}>
                <Message className="" mini onClose={null} title="Quota atteint" type="danger" visible>
                    {t('attendees.invitations.quotasError')}
                </Message>
            </div>
        );
    }
    return (
        <div className={css['error-icon']}>
            <Tooltip triggerOnHover title={t('ticket.common.validator_email')}>
                <Icon error name="message-warning" label="test" color="target" />
            </Tooltip>
        </div>
    );
}

export default TableError;
